export default "__VITE_ASSET__f307f712__"